<template>
  <el-dialog title="供应商扣分详情" :close-on-click-modal="false" width="90%"
             :visible.sync="visible" @close="onClose" append-to-body>
    <div v-loading="loading">
      <div class="penalty-info">{{ detail.supplier }}<span v-if="detail.info">（{{ detail.info }}）</span></div>
      <div class="penalty-summary">
        <span>质量分数：<b class="c-orange">{{ scores.quality }}</b></span>
        <span>成本分数：<b class="c-orange">{{ scores.cost }}</b></span>
        <span>交付分数：<b class="c-green">{{ scores.delivery }}</b></span>
        <span>服务分数：<b class="c-green">{{ scores.service }}</b></span>
        <span>开发分数：<b class="c-green">{{ scores.dev }}</b></span>
      </div>
      <el-tabs v-model="activeTab" @tab-click="tabChange">
        <el-tab-pane v-for="tab in tabKeys" :key="tab" :label="tab" :name="tab">
          <div class="reason-banner" v-if="tabData(tab)">
            <p class="reason-title">{{ tab }}扣分原因：</p>
            <p :class="['reason-text', {collapsed: !expanded}]">{{ tabData(tab).reason }}</p>
            <div class="reason-toggle" v-if="tabData(tab).reason && tabData(tab).reason.length > 80">
              <el-button type="text" @click="expanded = !expanded">{{ expanded ? '收起' : '展开更多' }}</el-button>
            </div>
          </div>
          <el-table :data="tabData(tab) ? tabData(tab).rows : []" size="mini" border :header-cell-style="{background:'#f5f5f5'}">
            <el-table-column prop="id" label="序号" width="60" align="center"></el-table-column>
            <el-table-column prop="category" label="评分分类" align="center"></el-table-column>
            <el-table-column prop="item" label="评分项" align="center"></el-table-column>
            <el-table-column prop="full" label="满分" width="70" align="center"></el-table-column>
            <el-table-column prop="actual" label="实得分" width="70" align="center"></el-table-column>
            <el-table-column label="扣分数" width="70" align="center">
              <template slot-scope="scope">
                <span :style="{color: scope.row.deduct > 0 ? '#e6a23c' : '#67c23a'}">{{ scope.row.deduct }}</span>
              </template>
            </el-table-column>
            <el-table-column label="扣分原因" min-width="200">
              <template slot-scope="scope">
                <span>{{ scope.row.reason }}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getSupplierPenaltyDetail } from '@/controller/supplier'
export default {
    data () {
        return {
            visible: false,
            loading: false,
            activeTab: '质量',
            expanded: false,
            tabKeys: ['质量', '成本', '交付', '服务', '开发'],
            detail: { supplier: '', info: '', scores: {}, tabs: {} },
        }
    },
    computed: {
        scores () {
            return this.detail.scores || {}
        }
    },
    methods: {
        init (row) {
            this.visible = true
            this.activeTab = '质量'
            this.expanded = false
            this.detail = { supplier: '', info: '', scores: {}, tabs: {} }
            this.loading = true
            getSupplierPenaltyDetail({
                venderCode: row.venderCode,
                evaYear: row.evaYear != null ? String(row.evaYear) : null,
                evaType: row.evaType != null ? String(row.evaType) : null,
                purOrg: row.purOrg,
                yearMonth: row.yearMonth,
                brand: row.brand,
                factory: row.factory
            }).then(data => {
                if (data && data.code === '00') {
                    this.detail = data.body || {}
                }
            }).catch((e) => {
                console.log(e)
            }).finally(() => {
                this.loading = false
            })
        },
        tabData (tab) {
            return (this.detail.tabs || {})[tab]
        },
        tabChange () {
            this.expanded = false
        },
        onClose () {
            this.$emit('close')
        }
    }
}
</script>

<style scoped>
.penalty-info { margin-bottom: 12px; color: #909399; font-size: 13px; }
.penalty-summary { background: #fff; padding: 10px 16px; margin-bottom: 12px; display: flex; flex-wrap: wrap; gap: 32px; font-size: 13px; }
.c-orange { color: #e6a23c; }
.c-green { color: #67c23a; }
.reason-banner { background: #f0fff4; border-bottom: 1px solid #e1f3d8; padding: 12px 16px; margin-bottom: 12px; }
.reason-title { font-weight: 500; color: #606266; font-size: 13px; margin: 0 0 6px; }
.reason-text { color: #67c23a; font-size: 13px; margin: 0; white-space: pre-wrap; }
.reason-text.collapsed { display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden; }
.reason-toggle { text-align: center; margin-top: 8px; }
.reason-row-title { font-weight: 500; color: #303133; margin: 0; }
.reason-row-note { color: #c0c4cc; font-size: 11px; margin: 2px 0 0; }
</style>
